// Solution landing page configs. `special` is optional and unlocks the
// bespoke content sections defined in the spec.

export const solutions = [
  {
    slug: "blister-printing",
    name: "Pharmaceutical Blister Printing Solutions",
    eyebrow: "Pharmaceutical Solutions",
    intro: [
      "Reliable blister-pack printing requires the correct combination of ink, printing conditions and substrate compatibility.",
      "Axion Group supplies specialist blister printing inks and supporting products for pharmaceutical packaging applications.",
    ],
    productSolutionSlug: "blister-printing",
    heroImageKey: "sample-flatlay",
    heroAlt:
      "Pharmaceutical blister-pack printing samples on a technical flat-lay",
    seoDescription:
      "Specialist pharmaceutical blister-pack printing solutions — inks and supporting products supplied internationally from Dubai.",
    note: "No performance specifications have been invented on this page. Product suitability is confirmed through application review.",
    special: "blister-printing",
  },
  {
    slug: "specialty-inks",
    name: "Specialty Printing Inks",
    eyebrow: "Industrial Solutions",
    intro: [
      "Selected printing inks are supplied for identification, coding and marking applications on porous and non-porous substrates.",
      "Product suitability is confirmed through application review before any regular supply arrangement.",
    ],
    productSolutionSlug: "specialty-inks",
    heroImageKey: "sample-flatlay",
    heroAlt: "Industrial printing ink samples on a technical flat-lay",
    seoDescription:
      "Specialty printing inks for identification and marking on porous and non-porous substrates, supplied internationally from Dubai.",
  },
  {
    slug: "printing-aids",
    name: "Printing Aids & Maintenance",
    eyebrow: "Industrial Solutions",
    intro: [
      "Supporting products for specialised printing applications and print-station maintenance — inks-aids, reducers and cleaning consumables used alongside the printing ink range.",
      "Product suitability is confirmed through application review before any regular supply arrangement.",
    ],
    productSolutionSlug: "printing-aids",
    heroImageKey: "sample-flatlay",
    heroAlt: "Industrial printing aid and cleaning consumable samples on a technical flat-lay",
    seoDescription:
      "Printing aids, reducers and cleaning consumables for specialised printing applications and print-station maintenance, supplied internationally from Dubai.",
  },
  {
    slug: "coding-marking",
    name: "Coding & Marking Consumables for Production Environments",
    eyebrow: "Pharmaceutical Solutions",
    intro: [
      "Clear, reliable batch and product identification is an essential part of modern manufacturing operations.",
      "Our coding portfolio includes selected HP-compatible thermal inkjet consumables for industrial production applications.",
    ],
    productSolutionSlug: "coding-marking",
    heroImageKey: "problem-tij-coding",
    heroAlt:
      "Thermal inkjet printer coding batch and expiry data on a pharmaceutical carton",
    seoDescription:
      "Coding & marking consumables including HP-compatible thermal inkjet cartridges for production environments, supplied internationally from Dubai.",
    special: "coding-marking",
  },
];

export const findSolution = (slug) => solutions.find((s) => s.slug === slug);

export const ASSESSMENT_STEPS = [
  "Application Assessment",
  "Sample Testing",
  "Technical Discussion",
  "Commercial Supply",
];
